import React from 'react';
import DataRequestGuide from '../../components/DataRequestGuide';

const steps = [
  {
    id: 'google-language',
    stepLabel: 'Prerequisite',
    title: 'Set your Google language to English (if not already)',
    image: process.env.PUBLIC_URL + '/Images/steps/Gemini_Step_Prereq.png',
    body: (
      <>
        To ensure the instructions match your experience, set
        your Google account language to <strong>English</strong> temporarily.
        You can change it back after completing the data export. To do this, go
        to your{' '}
        <a
          href="https://myaccount.google.com/language"
          target="_blank"
          rel="noreferrer"
        >
          Language Settings
        </a>{' '}
        and select <strong>English</strong> as your preferred language.
      </>
    ),
  },
  {
    id: 'gemini-step-1',
    stepLabel: 'Step 1',
    title: 'Open Google Takeout and deselect everything',
    image: process.env.PUBLIC_URL + '/Images/steps/Gemini_Step1.png',
    imageAlt: 'Google Takeout with Deselect all highlighted',
    body: (
      <>
        Go to{' '}
        <a
          href="https://takeout.google.com"
          target="_blank"
          rel="noreferrer"
        >
          Google Takeout
        </a>
        . On the first page, click <strong>Deselect all</strong> so that no
        product is selected yet.
      </>
    ),
  },
  {
    id: 'gemini-step-2',
    stepLabel: 'Step 2',
    title: 'Select “My Activity” only',
    image: process.env.PUBLIC_URL + '/Images/steps/Gemini_Step2.png ',
    imageAlt: 'My Activity product highlighted in Google Takeout',
    body: (
      <>
        Scroll down and tick the checkbox next to{' '}
        <strong>My Activity</strong>. This is where your Gemini data is stored.
        Make sure other products stay unchecked.
      </>
    ),
  },
  {
    id: 'gemini-step-3',
    stepLabel: 'Step 3',
    title: 'Open the format settings',
    image: process.env.PUBLIC_URL + '/Images/steps/Gemini_Step3.png',
    imageAlt: 'Multiple formats button highlighted',
    body: (
      <>
        Under <strong>My Activity</strong>, click the{' '}
        <strong>Multiple formats</strong> button to adjust how the data will be
        exported.
      </>
    ),
  },
  {
    id: 'gemini-step-4',
    stepLabel: 'Step 4',
    title: 'Ensure JSON format for export',
    image: process.env.PUBLIC_URL + '/Images/steps/Gemini_Step4.png',
    imageAlt: 'My Activity options with JSON format selected',
    body: (
      <>
        In the <strong>My Activity options</strong> window, set{' '}
        <strong>Activity records</strong> to{' '}
        <strong>JSON</strong>. Then click <strong>OK</strong>.
      </>
    ),
  },
  {
    id: 'gemini-step-5',
    stepLabel: 'Step 5',
    title: 'Choose which activity data to include',
    image: process.env.PUBLIC_URL + '/Images/steps/Gemini_Step5.png',
    imageAlt: 'All activity data included button highlighted',
    body: (
      <>
        Click{' '}
        <strong>All activity data included</strong> for My Activity. This lets
        you pick only Gemini Apps activity in the export.
      </>
    ),
  },
  {
    id: 'gemini-step-6',
    stepLabel: 'Step 6',
    title: 'Select Gemini Apps',
    image: process.env.PUBLIC_URL + '/Images/steps/Gemini_Step6.png',
    imageAlt: 'Gemini Apps selected in My Activity content options',
    body: (
      <>
        In the content options, tick <strong>Gemini Apps</strong>. These contain your Gemini conversations. When you’re done, click <strong>OK</strong>.
      </>
    ),
  },
  {
    id: 'gemini-step-7',
    stepLabel: 'Step 7',
    title: 'Go to the next step',
    image: process.env.PUBLIC_URL + '/Images/steps/Gemini_Step7.png',
    imageAlt: 'Next step button highlighted in Google Takeout',
    body: (
      <>
        Scroll to the bottom of the page and click <strong>Next step</strong> to
        move on to the export settings.
      </>
    ),
  },
  {
    id: 'gemini-step-8',
    stepLabel: 'Step 8',
    title: 'Create your export',
    image: process.env.PUBLIC_URL + '/Images/steps/Gemini_Step8.png',
    imageAlt: 'Create export button highlighted in Google Takeout',
    body: (
      <>
        Finally, click <strong>Create export</strong>.
        Google will prepare your archive and send you a download link by <strong>email</strong>.
      </>
    ),
  },
];

const GeminiRequest = () => (
  <DataRequestGuide
    title="How to Request Your Gemini Data"
    intro="Follow these steps in Google Takeout to export the activity data that contains your Gemini conversations. Once you receive and download the archive, you can donate it on this website."
    steps={steps}
  />
);

export default GeminiRequest;
